import * as React from "react";
import { Helmet } from "react-helmet";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import "./all.sass";
import "../styles/global.css";
import useSiteMetadata from "./SiteMetadata";
import { withPrefix } from "gatsby";

const TemplateWrapper = ({ children }) => {
  const { title, description, siteUrl } = useSiteMetadata();

  const themeBootScript = `
    (function () {
      var savedTheme = localStorage.getItem('theme');
      var theme = savedTheme || 'light';
      document.documentElement.setAttribute('data-theme', theme);
      var metaTheme = document.querySelector('meta[name="theme-color"]');
      if (metaTheme) {
        metaTheme.setAttribute('content', theme === 'dark' ? '#111827' : '#ffffff');
      }
    })();
  `;

  React.useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    const activeTheme = savedTheme || 'light';
    document.documentElement.setAttribute('data-theme', activeTheme);

    const metaTheme = document.querySelector('meta[name="theme-color"]');
    if (metaTheme) {
      metaTheme.setAttribute(
        'content',
        activeTheme === 'dark' ? '#111827' : '#ffffff'
      );
    }
  }, []);
  
  return (
    <div className="site-shell">
      <Helmet>
        <html lang="en" />
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="color-scheme" content="light dark" />
        <script>{themeBootScript}</script>

        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={`${withPrefix("/")}img/apple-touch-icon-180x180.png`}
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix("/")}img/favicon-32x32.png`}
          sizes="32x32"
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix("/")}img/favicon-16x16.png`}
          sizes="16x16"
        />

        <link
          rel="mask-icon"
          href={`${withPrefix("/")}img/predinfer-safari-pinned-tab.svg`}
          color="#ff4400"
        />
        <meta name="theme-color" content="#ffffff" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:site_name" content={siteUrl} />
      </Helmet>
      <Navbar />
      <main className="site-main">{children}</main>
      <Footer />
    </div>
  );
};

export default TemplateWrapper;
